import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import * as moment from "moment";
import { Constants } from '../constants';

declare var $: any;
declare var toastr: any;
declare var Nanobar: any;

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css']
})
export class SubscriptionsComponent implements OnInit {

  nao = new Nanobar();
  priceIconForSingle: string = Constants.iconForSinglePrice;
  priceIconForDouble: string = Constants.iconForDoublePrice;

  statusFilterString: string = 'Status - All' // Running, Paused or Cancelled
  statusFilter: number = -1 // 0 = Running,1 = Paused or 2 = Cancelled
  typeFilterString: string = 'Type - All' // Weekly or Monthly
  typeFilter: number = -1 // 0 = Weekly, 1 = Monthly
  businessFilterString: string = 'Business - All'
  businessSearchString: string = ''
  businessSearchList: any;
  business_id: number;
  searchSubscriptionString: string = '';
  
  // Subscription Listing vairables
  subscriptionData: any = [];
  subscriptionList: any [] = [];
  limitOrder: number = 20;
  pageNumber: number = 0;
  index_of_first: number;
  last_page: boolean = false;
  btnShowAfterDataLoad: boolean = false;
  Paginationdisable: boolean = false;

  //Response Varaibles
  statusUpdateResponse: any;

  orderData: any = [];
  // Order Detail Variables
  orderDetailToReopenOpId: any;
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  userDropDocs: any;
  orderDataDisplay: any;
  dineIn: any;
  tableNo: any;
  pickUp: any;
  pickupAddress: any;
  productData: any;
  thirdPartyData: any;
  onDetailDriverData: any;
  returnOrderItems: any;
  returnOrderItemsLength: any;
  orderCreated: any;
  orderBooked: any;
  deliverStartDate: any;
  deliverEndDate: any;
  
  searchTimeOut: any;

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.getsubscriptions();
    this.getBusinesses();
  }

  getBusinesses() {
    this.dataService.getdispensaryListingById(localStorage.getItem('token'), -1, this.businessSearchString).subscribe(
      (data) => {
        this.businessSearchList = data;
        console.log("Business List: ", this.businessSearchList);
      },
      (error) => {
        console.log('error', error);
        toastr.error('Some thing went wrong');
      }
    );
  }

  getsubscriptions() {
    this.nao.go(30)
    this.dataService.getSubscriptions(localStorage.getItem('token'), this.pageNumber, this.limitOrder, this.statusFilter, this.typeFilter, this.searchSubscriptionString, this.business_id).subscribe(
      (data) => {
        this.nao.go(100)
        console.log(data);
        this.pageNumber = 0;
        this.subscriptionData = data;
        this.index_of_first = this.subscriptionData.index_of_first;
        this.subscriptionList = this.subscriptionData.items;
        this.subscriptionList.forEach(subscription => {
          subscription.order__created_on = moment(subscription.recent_order__created_on).local().format('lll');
        });
        this.pageNumber = this.subscriptionData.page;
        this.last_page =  this.subscriptionData.last_page;
        console.log('subscription List: ', this.subscriptionList);
      }, (error) => {
        console.log('Error getting subscriptions,', error);
      }
    )
  }

  changeStatus(index, subscription_id, status) {
    $('.processOrderNewImg' + index).css('display', 'none'); // hide process img to show loader
    $('#procesLoader' + index).css('display', 'inline-block'); // show loader

    this.dataService.changeSubscriptionStatus(localStorage.getItem('token'), subscription_id, status).subscribe(
      (data) => {
        console.log("Status updated", data);
        $('.processOrderNewImg' + index).css('display', 'inline-block');
        $('#procesLoader' + index).css('display', 'none');
        this.statusUpdateResponse = data;
        if(this.statusUpdateResponse.Success == true){
          this.getsubscriptions();
        }
      }, (err) => {
        console.log("Error while changing status: ", err)
      }
    );
  }

  cancelSubscription(index, subscription_id, status) {
    $('.cancelOrderNewImg' + index).css('display', 'none');
    $('#cancelLoader' + index).css('display', 'inline-block');

    this.dataService.changeSubscriptionStatus(localStorage.getItem('token'), subscription_id, status).subscribe(
      (data) => {
        console.log("Status updated", data);
        $('.cancelOrderNewImg' + index).css('display', 'inline-block');
        $('#cancelLoader' + index).css('display', 'none');
        this.statusUpdateResponse = data;
        if(this.statusUpdateResponse.Success == true){
          this.getsubscriptions();
        }
      }, (err) => {
        console.log("Error while changing status: ", err)
      }
    );
  }

  filterByStatus(status: number, statusString: string) {
    this.statusFilter = status;
    this.statusFilterString = statusString;
    this.getsubscriptions();
  }

  filterByType(status: number, statusString: string) {
    this.typeFilter = status;
    this.typeFilterString = statusString;
    this.getsubscriptions();
  }

  filterBusinessId(business_id: number, business_name: string) {
    this.business_id = business_id;
    this.businessFilterString = business_name;
    this.getsubscriptions();
  }

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), -1, this.businessSearchString).subscribe(
        (data) => {
          this.businessSearchList = data;
        },
        (error) => {
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
      );
    });
  }

  searchAllSubscriptions() {
    clearTimeout(this.searchTimeOut);
    this.pageNumber = 0;
    this.searchTimeOut = setTimeout(() => {
      this.getsubscriptions();
    }, 1000);
  }

  clearSearch() {
    this.pageNumber = 0;
    this.searchSubscriptionString = '';
    this.searchAllSubscriptions();
  }

  orderDetailCall(id) {
    this.nao.go(30);
    this.orderDetailToReopenOpId = id;
    this.dataService.getOrderhDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.orderDetailData = data;
        this.orderDetailData.transaction_missing = false;
        if(this.orderDetailData.payment_type == 'Bank Transfer' && (!this.orderDetailData.transaction_id && this.orderDetailData.transaction_id == '')) {
          this.orderDetailData.transaction_missing = true;
        }
        this.customerDetail = this.orderDetailData.customer_detail;
        this.droppOffAddress = this.orderDetailData.dropoff_address;
        // we have to work here
        this.userDropDocs = this.orderDetailData.drop_off_docs;
        console.log('userDropDocs', this.userDropDocs);
        this.orderDataDisplay = this.orderDetailData.order;
        console.log(this.orderDataDisplay);
        let order_type = this.orderDataDisplay.delivery_man_type;
        if (order_type === 4) {
          this.dineIn = true;
          this.tableNo = this.orderDataDisplay.dine_in_table_number;
        } else {
          this.dineIn = false;
          this.tableNo = '';
        }
        if (order_type === 5) {
          this.pickUp = true;
        } else {
          this.pickUp = false;
        }
        this.pickupAddress = this.orderDetailData.pickup_address;
        this.productData = this.orderDetailData.product;
        this.thirdPartyData = this.orderDetailData.third_party;
        this.onDetailDriverData = this.orderDetailData.driver;
        this.returnOrderItems = this.orderDataDisplay.return_items['return_product_list'];
        this.returnOrderItemsLength = this.returnOrderItems.length;
        this.orderCreated = this.orderDetailData.order_created_by;
        this.orderBooked = this.orderDetailData.order_booked_by;
        // console.log('this.orderCreated', this.orderCreated);
        console.log('this.onDetailDriverData', this.onDetailDriverData);
        $('#orderDetailPop').modal('show');

        var cDate = new Date().getDate();
        var cYear = new Date().getFullYear();
        var cMonth = new Date().getUTCMonth() + 1;
        var openTime = this.orderDataDisplay.open_time;
        var tOpen = cYear + '/' + cMonth + '/' + cDate + ' ' + openTime + ' ' + 'UTC';
        var dateObjOpen = new Date(tOpen);
        this.deliverStartDate = dateObjOpen;

        var closeTime = this.orderDataDisplay.close_time;
        var tClose = cYear + '/' + cMonth + '/' + cDate + ' ' + closeTime + ' ' + 'UTC';
        var dateObjClose = new Date(tClose);
        this.deliverEndDate = dateObjClose;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/subscriptions/subscriptions.component.ts